import React, {useEffect, useState} from "react";
import axios from "axios";
import {isNull} from "lodash";
import ListDisplayContext from "../components/ListDisplayContext";
import Columns from "../components/Columns";
import getListBrandsGroups from "../helpers/getListBrandsGroups";
import getListBrands from "../helpers/getListBrands";
import sortBrands from "../helpers/sortBrands";
import getListBrandsInCountries from "../helpers/getListBrandsInCountries";
import getListCountries from "../helpers/getListCountries";
import Modal from "react-modal";


Modal.setAppElement(document.getElementsByClassName('amrest-brands-popup-big'));

const BrandsPopup = (props) => {
    const language = drupalSettings.path.currentLanguage || ''

    const ENDPOINTS = {
        countries: '/' + language + '/api/taxonomy/countries',
        brands: '/' + language + '/api/taxonomy/brands',
        brandsInCountries: '/' + language + '/api/taxonomy/brands_in_countries'
    }

    const [statusIcon, setStatusIcon] = useState(null);

    const [availableOptions, setAvailableOptions] = useState({
        countries: [],
        brands: [],
        brandsInCountries: []
    });
    const [brandsGroups, setBrandsGroups] = useState({
        proprietary: [],
        franchise: [],
        virtual: [],
    });
    const [loaded, setLoaded] = useState(false);

    const [selectedBrand, setSelectedBrand] = useState(null);

    useEffect(() => {
        axios
            .all(
                [
                    axios.get(ENDPOINTS.countries),
                    axios.get(ENDPOINTS.brands),
                    axios.get(ENDPOINTS.brandsInCountries)
                ])
            .then(axios.spread((...responses) => {
                if (responses[0].status === 200 &&
                    responses[1].status === 200 &&
                    responses[2].status === 200) {
                    //let mappedData = mapData(responses[0].data, responses[1].data, responses[2].data);

                    //setData(mappedData);
                    setLoaded(true);
                    setAvailableOptions({
                        countries: getListCountries(responses[0].data),
                        brands: getListBrands(responses[1].data),
                        brandsInCountries: getListBrandsInCountries(responses[2].data)
                    });
                    setBrandsGroups(getListBrandsGroups(responses[1].data, props.brandIds));
                } else {
                    setStatusIcon("fas fa-exclamation-triangle py-3");
                }
            }))
            .catch(err => {
                setStatusIcon("fas fa-exclamation-triangle py-3");
            });
    }, []);


    const contextValue = {
        brandsGroups: brandsGroups,
        availableOptions: availableOptions,
        setAvailableOptions: item => setAvailableOptions(item),
        selectedBrand: selectedBrand,
        setSelectedBrand: item => setSelectedBrand(item),
    };


    if (loaded === true) {
        return (
            <ListDisplayContext.Provider value={contextValue}>
                <Columns/>
            </ListDisplayContext.Provider>
        );
    } else {
        if (isNull(statusIcon)) {
            return (
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">{Drupal.t("Loading...")}</span>
                  </div>
                </div>
            );
        } else {
            return (
                <div className="d-flex justify-content-center">
                  <i className={`${statusIcon}`}></i>
                </div>
            );
        }
    }
};

export default BrandsPopup;
